export default {
  NUMERO_CARTAO: "Número do Cartão",
  NOME_CARTAO: "Nome no Cartão",
  CPF_CNPJ: "CPF",
  DATA_EXPIRACAO: "Data de Expiração",
  MES_VENCIMENTO: "Mês Venc.",
  ANO_VENCIMENTO: "Ano Venc.",
  CODIGO_SEGURANCA: "Cód. Seg. (CVV)",
  ENDERECO: "Endereço",
  LOGRADOURO: "Logradouro",
  NUMERO: "Número",
  COMPLEMENTO: "Complemento",
  BAIRRO: "Bairro",
  CIDADE: "Cidade",
  ESTADO: "Estado",
  UF: "UF",
  CEP: "CEP",
  VALOR: "Valor",
  VALOR_PARCIAL: "Valor parcela",
  VALOR_TOTAL: "Valor Total",
  TOTAL_PARCELAS: "Parcelas",
  MENSAGEM_SUCESSO: "Operação efetuada com sucesso",
  QUANTIDADE_CARTOES: "Selecione a quantidade de Cartões",
  TELEFONE: "Telefone",
  COMPRADOR: "Informações do comprador",
  COBRANCA: "Endereço de cobrança",
  LINK_EXPIRADO: "O link está expirado, ele tem duração de 30 minutos.",
  LINK_EXPIRADO2: "Favor gerar uma nova guia.",
  REINICIAR_PROCESSO: "Ocorreu erro no processo de pagamento.",
  ERRO_PAGAMENTO: "Ocorreu um erro no processo de pagamento e o mesmo não foi concluído.",
  ERRO_PAGAMENTO2: "Pode fechar essa aba e reiniciar o processo de pagamento.",
  TAXAS: "Taxas",
  AGUARDANDO_CONFIRMACAO: "Processo de pagamento foi iniciado.",
  AGUARDANDO_CONFIRMACAO_MSG: "Aguardando a confirmação do pagamento.",
  DADOSPAGADOR: "Informações do pagamento",
  NOME: "Nome:",
  PAGAMENTO: "Pagamento realizado: ",
  EM: " em ",
  PARCELAS: " parcelas",
  VALORCONFIRMACAO: "Valor: ",
  PAGAMENTO_NEGADO: "Pagamento negado no emissor",
  TENTATIVA_PAGAMENTO: "Tentativa de pagamento realizado: ",
  MENSAGEM_OPERADORA: "Mensagem original do emissor:",
  EMAIL: "E-mail",

  // Orientação de preenchimento do pagador: os erros mais comuns do checkout
  // eram recusas da adquirente por dado digitado errado, que o cliente já sabe
  // conferir antes de enviar.
  PLACEHOLDER_NUMERO_CARTAO: "Somente os números do cartão",
  PLACEHOLDER_NOME_CARTAO: "Como está impresso no cartão",
  PLACEHOLDER_CVV: "3 ou 4 dígitos no verso",
  PLACEHOLDER_CPF: "CPF do titular do cartão",
  PLACEHOLDER_EMAIL: "nome@exemplo.com.br",
  NUMERO_CARTAO_INVALIDO:
    "Número do cartão inválido. Confira os dígitos impressos na frente do cartão.",
  CARTAO_VENCIDO:
    "Este cartão está vencido. Confira o mês e o ano de validade ou use outro cartão.",
  SOMA_CARTOES_DIFERENTE:
    "A soma dos valores dos cartões ({soma}) precisa ser igual ao valor total ({total}). Ajuste o valor de um dos cartões.",
};
